export const SPLIT_TEST: Record<string, string | undefined> = {
  quickMessage: import.meta.env.VITE_APP_SPLIT_TEST_ZERO_FREE_MSG,
  showOverlayInNotifications: import.meta.env
    .VITE_APP_SPLIT_TEST_NOTIFICATION_OVERLAY,
  paidVideoMails: import.meta.env.VITE_APP_SPLIT_TEST_PAID_VIDEO_MAILS,
  sticker: import.meta.env.VITE_APP_SPLIT_TEST_STICKER_IN_CHAT,
  chatStub: import.meta.env.VITE_APP_SPLIT_TEST_CHAT_STUB,
  sparkSwipeProfile: import.meta.env.VITE_APP_SPLIT_TEST_SPARK_SWIPE_PROFILE,
  reducedWizard: import.meta.env.VITE_APP_SPLIT_TEST_REDUCED_WIZARD,
  profilePreview: import.meta.env.VITE_APP_SPLIT_TEST_PROFILE_PREVIEW,
};

export const SPLIT_TEST_STATUS_ACTIVE = 1;

export const brandsWithProfilePreview = [
  "amourlee",
  "latinmelodies",
  "cupidticket",
];
